<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='出科特殊科室设置'></PageHead>
      <div class="m-portlet__body">
        <el-tabs v-model="activeName">
          <el-tab-pane label="当前设置" name="first">
            <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="form"
              ref="form">
              <el-checkbox-group v-model="form.managesec">
                <el-checkbox v-for="item in managesecOptions" :key="item.DictItemID" :label="item.DictItemID" name="managesec"
                  style="width:150px;font-size: 20px;">{{item.DictItemName}}</el-checkbox>
              </el-checkbox-group>
              <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;float: initial;">
                <el-button type="success" icon="el-icon-s-order" @click="Save" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
              </div>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="历史记录" name="second">
            <el-table :data="tableData" stripe style="width: 100%" size="medium">
              <el-table-column prop="SectionList" label="设置范围">
              </el-table-column>
              <el-table-column label="设置时间">
                <template slot-scope="scope">
                  {{scope.row.SetTime|formatFullDate}}
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'UserAdd',
    data() {
      return {
        form: {
          token: '',
          username: '',
          rolelevel: '',
          managesec: []
        },
        managesecOptions: [],
        fullscreenLoading: false,
        activeName: 'first',
        tableData: []
      }
    },
    filters: {
      formatFullDate(val) {
        var now = new Date(val)
        var y = now.getFullYear()
        var m = now.getMonth() + 1
        var d = now.getDate()
        return y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d)
      }
    },
    methods: {
      LoadManageSec: function() {
        var args = {
          token: this.form.token,
          username: this.form.username,
          rolelevel: this.form.rolelevel
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/ManageSecionList', args, function(data) {
          that.managesecOptions = data.Data
          that.LoadOutApplyManageSec()
        }, null, null, null)
      },
      LoadOutApplyManageSec: function() {
        var args = {
          token: this.form.token,
          username: this.form.username,
          rolelevel: this.form.rolelevel
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APICyclePlan/GetOutApplyManageSec', args, function(data) {
          if (data.Data != null) {
            var list = data.Data
            list.forEach(function(item) {
              var arg = item.ManageSec
              that.form.managesec.push(arg)
            })
          }
          console.log(that.form.managesec)
        }, null, null, null)
      },
      Save: function() {
        console.log(this.form.managesec)
        if (this.form.managesec.length == 0) {
          this.$message({
            message: '没有设置任何科室',
            type: 'warning'
          })
          return
        }
        var that = this
        this.fullscreenLoading = true
        this.$http.post(this.$utils.Url.zpgl + '/api/APICyclePlan/OutApplyManageSecSet', this.form)
          .then(res => {
            if (res.data.Code === 0) {
              that.$message({
                message: '保存成功',
                type: 'success'
              })
              console.log('保存成功')
              that.LoadRecord()
            } else {
              that.$message({
                message: res.data.Msg + '，' + res.data.Data,
                type: 'error'
              })
            }
            that.fullscreenLoading = false
          })
          .catch(err => {
            console.log(err)
            that.$message({
              message: '保存失败',
              type: 'error'
            })
            that.fullscreenLoading = false
          })
      },
      LoadRecord: function() {
        var that = this
        var args = {
          token: this.form.token
        }
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APICyclePlan/OutApplyManageSectionRecordList', args, function(data) {
          that.tableData = data.Data
        }, null, null)
      }
    },
    mounted: function() {
      this.form.token = sessionStorage.getItem('token')
      this.form.username = sessionStorage.getItem('username')
      this.form.rolelevel = sessionStorage.getItem('rolelevel')
      this.LoadManageSec()
      this.LoadRecord()
    }
  }
</script>

<style>
</style>
